module.exports = __webpack_public_path__ + "static/media/kettleIcon.6024826f.svg";